export const engagementReportBuilder2AppGroupIdSegmentAnalyticsTrackingWindows =
  "/engagement/report_builder_2/:app_group_id/segment_analytics_tracking_windows";
